import React from 'react';

import {connect} from 'react-redux';

import TextHalf from '../../../elements/viewData/textHalf'
import {modifiDateString} from '../../../../redux/modifiDate'

const DateModified = (props) => {
    if(props.auctionId !== null){
        if(props.auctionId.hasOwnProperty('dateModified')){
            if(props.auctionId.dateModified !== null){
                let tmp = `${modifiDateString(props.auctionId.dateModified, 3)}`
                return (
                    <TextHalf
                        title='Остання дата зміни процедури'
                        data={tmp}
                    />
                )
            }
        }
    }
    return null
}

const mapStateToProps = state => {
    return {
        auctionId: state.start.auctionFull,
    }
}

export default connect(mapStateToProps, null)(DateModified)